var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgChangelogs = function SvgChangelogs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 5.397v-.081L8.426 1.794l-.692.729 2.297 2.874H6.562V0H0v17h11.25V5.397zm-.938 10.524H.938V1.079h4.687v5.397h4.688v9.445zM3.282 9.31v1.079h4.687v-1.08H3.28zm0 3.912v-1.08h4.687v1.08H3.28z"
  })));
};

export default SvgChangelogs;